import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "19",
  height: "17",
  fill: "none",
  viewBox: "0 0 19 17"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11.043 1.333c0-.46.373-.833.833-.833h.847a1.68 1.68 0 0 1 1.68 1.683v2.972a.833.833 0 1 1-1.666 0V2.183a.02.02 0 0 0-.005-.012l-.009-.004h-.847a.833.833 0 0 1-.833-.834m-2.464.85L2.563 4.81l-.006.007a.02.02 0 0 0 0 .013l.003.007 4.166 10.1 6.016-2.627.007-.008a.02.02 0 0 0 0-.014l-.003-.007zM8.581.508a1.64 1.64 0 0 1 1.537 1.033l4.167 10.101a1.685 1.685 0 0 1-.865 2.19l-.006.002-6.048 2.642a1.644 1.644 0 0 1-2.179-.9L1.02 5.477a1.685 1.685 0 0 1 .865-2.189l.006-.002L7.941.642c.202-.086.42-.132.64-.133m6.763 2.197a.833.833 0 0 1 1.093-.44q.327.138.631.259l.02.008a1.68 1.68 0 0 1 .89 2.204l-.001.003-1.946 4.564a.833.833 0 1 1-1.533-.654l1.945-4.562a.02.02 0 0 0 0-.014l-.006-.007a29 29 0 0 1-.652-.268.833.833 0 0 1-.44-1.093",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }